import { WorkOrderTaskType } from '@xbcb/work-order-types';

export const ASSIGNMENT_QUEUE = 'Assignment Queue';
export const DEEP_THOUGHT_RUM_EVENT_PROGRAM_NAME = 'agl.cbms.deepthought';
export const HTS_RECOMMENDATION_TEXT =
  'Based on your input, AI recommends the HTS number';
export const NRBS_RECORD_NUMBER_LEN = 10;
export const WOT_TYPES_WITH_COMMODITY_GROUPS = [
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_BUILD_INVOICE,
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_COMPLETION_SUBMISSION,
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_CONSOLIDATION_COMPLETION,
  WorkOrderTaskType.US_CONSUMPTION_ENTRY_SPLIT_COMPLETION_SUBMISSION,
];
